module.exports = __webpack_public_path__ + "img/parallel.15c81bfb.png";